import React from "react";
import EnrollmentForm from "../../../components/enrollments/EnrollmentForm";
export default function AdminEnrollmentFormPage() {
    return <EnrollmentForm role="ADMIN" />;
}
